exports = module.exports = require("../../../../../../legacy/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".coins-amount[data-v-3256b41e] {\n  font-weight: bolder;\n  color: #5f6261;\n}\n.coins-amount img[data-v-3256b41e] {\n  margin-left: 4px;\n  width: 14px;\n  height: 14px;\n}", ""]);

// exports
